import { LineasAsientosContablesByFilterDtoIProps } from "api/DTOs/LineasAsientosContablesByFilterDto"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"

export const NombreCuentaContableAsiento = ({
  cuentaContable: {
    id: cuentaContableId = "",
    numero: numeroCuentaContable,
  } = {},
}: LineasAsientosContablesByFilterDtoIProps) => {
  const history = useHistory()

  const handleRedirectToDetail = (id: string) => {
    history.push(`${ROUTES.LIBRO_MAYOR}/${id}`)
  }
  return (
    <p
      onClick={() => {
        !window.location?.pathname?.includes(ROUTES.LIBRO_MAYOR) &&
          handleRedirectToDetail(cuentaContableId)
      }}
      className='hover:tw-underline tw-text-info tw-cursor-pointer tw-text-sm tw-m-0 tw-p-0'
    >
      {numeroCuentaContable}
    </p>
  )
}

export const filterLineaVacia = (lineas: $TSMigrationFixMe) => {
  return lineas?.filter(
    ({ cuentaContableId }: $TSMigrationFixMe) => cuentaContableId
  )
}

export const filterLineaVaciaTaxes = (lineas: $TSMigrationFixMe) => {
  return lineas?.filter((element: $TSMigrationFixMe) => {
    return (
      element.porcentajeImpuesto !== null || element.porcentajeImpuesto?.valor
    )
  })
}
